import axios from 'axios';

const saveConditionAcceptation = (payload = {}) => {
    return axios.post('/quickpay/save_condition_acceptation', payload);
};

export { saveConditionAcceptation };
